<!-- eslint-disable -->
<template lang="pug">
    .abacus(ref="abacus")
        .abacus__plank-container
            .abacus__plank.abacus__plank--large
        .abacus__bones-block
            .abacus__digit-block(v-for='digit in digitsArray')
                .abacus__rod
                .abacus__bone.abacus__bone--bottom(v-if='digit >= 5')
                .abacus__bone.abacus__bone--top(v-else='')
        .abacus__plank-container
            .abacus__plank
        .abacus__bones-block
            .abacus__digit-block(v-for='digit in digitsArray')
                .abacus__rod
                .abacus__bone.abacus__bone--top(v-for='n in digit%5')
                .abacus__bone.abacus__bone--bottom(v-for='n in 4 - digit%5')
        .abacus__plank-container
            .abacus__plank.abacus__plank--large
</template>

<script>
    /*eslint-disable*/
    const GAME_INFO_SCHULTE_TABLE_CELL_CLASSNAME = '.example-table__cell';

    export default {
        props: {
            number: Number,
            digits: Number,
            maxNumber: {
                type: Number,
                default: undefined
            },
            isBattleOpponent: {
                type: Boolean,
                default: false,
            },
            itemSize: {
                type: Number,
                default: 100
            },
            isFromRenderTable: {
                type: Boolean,
                default: true
            }
        },
        mounted() {
            this.isFromRenderTable && this.calculateAbacusSizes();
        },
        computed: {
            digitsArray () {
                if (this.maxNumber > 9 && this.number <= 9) {
                    return [0, ...this.number.toString().split('')].map(Number);
                }
                return this.number.toString().split('').map(Number);
            }
        },
        methods: {
            calculateAbacusSizes () {
                const initialAbacusHeight = document.querySelector('.abacus').clientHeight;
                let abacusContainerHeight = 0;
                if (!this.isBattleOpponent) {
                    abacusContainerHeight = document.querySelector('.abacus').parentElement.parentElement.clientHeight;
                } else {
                    abacusContainerHeight = document.querySelector(GAME_INFO_SCHULTE_TABLE_CELL_CLASSNAME).clientHeight;
                }
                const isSafari = /constructor/i.test(window.HTMLElement)
                    || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari']
                        || (typeof safari !== 'undefined' && safari.pushNotification));
                const isFirefox = typeof InstallTrigger !== 'undefined';
                if (isSafari || isFirefox || initialAbacusHeight > abacusContainerHeight) {
                    let coefficient = abacusContainerHeight * 0.85 / initialAbacusHeight;
                    coefficient *= isSafari ? 0.85 : isFirefox ? 1.05 : 1;
                    let selectors = [
                        '.abacus__bone', '.abacus__rod',
                        'div.abacus__plank:not(.abacus__plank--large)',
                        '.abacus__plank--large', '.abacus__digit-block'
                    ];
                    selectors.forEach(selector => {
                        this.recalculateElementsSizes(selector, coefficient);
                    });
                }
            },
            recalculateElementsSizes (selector, coefficient) {
                let elements = Array.from(document.querySelectorAll(selector));
                let elementHeight = elements[0].clientHeight;
                let elementWidth = elements[0].clientWidth;
                if (this.isBattleOpponent) {
                    elements = elements.slice(-elements.length / 2);
                }
                elements.forEach(element => {
                    element.style['width'] = elementWidth * coefficient + 'px';
                    if (selector === '.abacus__digit-block') {
                        element.style['margin'] = '0 auto';
                    } else {
                        element.style['height'] = elementHeight * coefficient + 'px';
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .abacus {
        display: flex;
        flex-direction: column;
    }

    .abacus__plank-container {
        display: flex;
        justify-content: center;
    }

    .abacus__plank {
        width: 100%;
        height: 17px;
        border-radius: 5px;
        $color-burgundy: #8b4220;
        $color-copper: #b87333;
        background: linear-gradient($color-copper, $color-burgundy);
        @include base-shadow;
    }
    .abacus__plank--large {
        height: 34px;
    }
    .abacus__bones-block {
        display: flex;
        flex-direction: row;
    }
    .abacus__digit-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 35px;
        @media only screen and (min-width: 350px) {
            width: 40px;
            margin: 0 $space-x-small;
        }
        @media only screen and (min-width: 450px) {
            width: 55px;
        }
        @media only screen and (min-width: 650px) {
            width: 70px;
            margin: 0 $space-base;
        }
        @media only screen and (min-width: 1000px) {
            margin: 0 $space-large;
        }
        @media only screen and (min-width: 1300px) {
            width: 85px;
            margin: 0 $space-x-large;
        }
    }

    .abacus__bone {
        border-radius: 25px;
        box-shadow: inset 0 0 10px 1px rgba(0, 0, 0, 0.2),
        inset -3px 0 3px rgba(255, 255, 255, 0.3);
        background: linear-gradient(to top, #4a7928, #76a554);
        height: 25px;
        width: 35px;
        @media only screen and (min-width: 350px) {
            height: 30px;
            width: 40px;
        }
        @media only screen and (min-width: 450px) {
            height: 35px;
            width: 55px;
        }
        @media only screen and (min-width: 650px) {
            height: 40px;
            width: 70px;
        }
        @media only screen and (min-width: 1300px) {
            height: 50px;
            width: 85px;
        }
    }

    .abacus__bone--top {
        order: 1;
    }

    .abacus__bone--bottom {
        order: 3;
    }

    .abacus__rod {
        height: 40px;
        width: 15px;
        order: 2;
        background: linear-gradient(to right, #8b4220, #b5743a);
        @media only screen and (min-width: 450px) {
            width: 20px;
        }
    }

    .multi-screen .abacus__digit-block {
        @media only screen and (min-width: 1000px) {
            width: 38px;
            margin: 0 calc(#{$space-x-small} / 2);
        }
        @media only screen and (min-width: 1280px) {
            width: 50px;
            margin: 0 $space-x-small;
        }
    }
    .multi-screen .abacus__bone {
        @media only screen and (min-width: 1000px) {
            height: 30px;
            width: 38px;
        }
        @media only screen and (min-width: 1280px) {
            height: 35px;
            width: 50px;
        }
    }
    .multi-screen .abacus__rod {
        @media only screen and (min-width: 1000px) {
            width: 15px;
        }
        @media only screen and (min-width: 1280px) {
            width: 20px;
        }
    }
</style>
